import { render } from "./PageStudentClass.vue?vue&type=template&id=6567a232"
import script from "./PageStudentClass.vue?vue&type=script&lang=js"
export * from "./PageStudentClass.vue?vue&type=script&lang=js"

import exportComponent from "/Users/shenshenmac/codes/fan_mei/fanmei_v3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__